import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { createResourcesApi } from '@helsenorge/framework-utils/resources';
import frameworkEnGB from './HN.Core.Framework.NPM.JS.en-GB.json';
import frameworkLtLT from './HN.Core.Framework.NPM.JS.lt-LT.json';
import frameworkNbNO from './HN.Core.Framework.NPM.JS.nb-NO.json';
import frameworkNnNO from './HN.Core.Framework.NPM.JS.nn-NO.json';
import frameworkPlPL from './HN.Core.Framework.NPM.JS.pl-PL.json';
import frameworkRoRO from './HN.Core.Framework.NPM.JS.ro-RO.json';
import frameworkRuRU from './HN.Core.Framework.NPM.JS.ru-RU.json';
import frameworkSeNO from './HN.Core.Framework.NPM.JS.se-NO.json';
import contentEnGB from './HN.Tjenester.Content.en-GB.json';
import contentNbNO from './HN.Tjenester.Content.nb-NO.json';
import contentNnNO from './HN.Tjenester.Content.nn-NO.json';
import contentSeNO from './HN.Tjenester.Content.se-NO.json';
export const Projects = {
    FRAMEWORK: 'HN.Core.Framework.NPM.JS',
    CONTENT: 'HN.Tjenester.Content',
};
const resourceMap = {
    'HN.Core.Framework.NPM.JS.en-GB': frameworkEnGB,
    'HN.Core.Framework.NPM.JS.lt-LT': frameworkLtLT,
    'HN.Core.Framework.NPM.JS.nb-NO': frameworkNbNO,
    'HN.Core.Framework.NPM.JS.nn-NO': frameworkNnNO,
    'HN.Core.Framework.NPM.JS.pl-PL': frameworkPlPL,
    'HN.Core.Framework.NPM.JS.ro-RO': frameworkRoRO,
    'HN.Core.Framework.NPM.JS.ru-RU': frameworkRuRU,
    'HN.Core.Framework.NPM.JS.se-NO': frameworkSeNO,
    'HN.Tjenester.Content.en-GB': contentEnGB,
    'HN.Tjenester.Content.nb-NO': contentNbNO,
    'HN.Tjenester.Content.nn-NO': contentNnNO,
    'HN.Tjenester.Content.se-NO': contentSeNO,
};
export const getBundledResources = (projectName, language) => {
    const key = `${projectName}.${language}`;
    return resourceMap[key];
};
export const fetchResources = async (projectName, language) => {
    const key = `${projectName}.${language}`;
    const resource = resourceMap[key];
    if (!resource) {
        throw new Error(`Failed to load resources for ${projectName} in ${language}`);
    }
    return Promise.resolve(resource);
};
export const { resourcesApi, useResources, useSuspenseResources } = createResourcesApi({
    fallbackLanguage: LanguageLocales.NORWEGIAN,
    getBundledResources: getBundledResources,
    fetchResources: fetchResources,
});
